<template>
<div data-v-327351f8="" data-v-e5781868="" class="container depositWays mainContent top50">
				<div data-v-327351f8="" class="content">
					<div data-v-327351f8="" class="row">
						<div data-v-327351f8="" class="t">
							<div data-v-327351f8="" class="title"><img data-v-327351f8="" src="/static/image/title.ec44d1a3.svg"></div>
							<div data-v-327351f8="" v-if="!$store.state.token" class="createAccount"><a data-v-327351f8="" class="button buttonSolid" @click="registerBox()">立即开户 <svg data-v-338e1447="" data-v-327351f8="" aria-hidden="true" class="svg-icon iconArrow">
								<use data-v-338e1447="" xlink:href="#icon-iconArrow"></use>
								</svg></a></div>
						</div>
						<div data-v-327351f8="" class="table">
							<table data-v-327351f8="" width="1328" cellpadding="0" cellspacing="1">
								<tbody><tr data-v-327351f8="">
									<th data-v-327351f8="" width="230" class="first">充值方式</th>
									<th data-v-327351f8="" width="150">充值类别</th>
									<th data-v-327351f8="" width="400">充值渠道</th>
									<th data-v-327351f8="" width="180">到账时间</th>
									<th data-v-327351f8="" width="200">交易限额</th>
									<th data-v-327351f8="" width="150">如何充值</th>
								</tr>
								<tr data-v-327351f8="" class="dark">
									<td data-v-327351f8="" rowspan="2" class="mi"><div data-v-327351f8="" class="icon"><img data-v-327351f8="" src="/static/image/rmb.0fae87c8.svg" class="img"></div>
										人民币 </td>
									<td data-v-327351f8="" class="st">快速支付</td>
									<td data-v-327351f8="" class="st">网银、手机转账、支付宝转账、ATM机现金充值等</td>
									<td data-v-327351f8="" class="st">实时到账</td>
									<td data-v-327351f8="" class="st">300-10万CNY</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
								<tr data-v-327351f8="" class="dark">
									<td data-v-327351f8="" class="st">大额存款</td>
									<td data-v-327351f8="" class="st">VIP客户专属通道</td>
									<td data-v-327351f8="" class="st">5-8分钟</td>
									<td data-v-327351f8="" class="st">20万CNY-无上限</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
								<tr data-v-327351f8="" class="light">
									<td data-v-327351f8="" rowspan="3" class="mi"><div data-v-327351f8="" class="icon"><img data-v-327351f8="" src="/static/image/crypto.c6750ec4.svg" class="img"></div>
										数字币 </td>
									<td data-v-327351f8="" class="st">银联充币</td>
									<td data-v-327351f8="" class="st">使用网银/微信/支付宝于交易所购买币</td>
									<td data-v-327351f8="" rowspan="3" class="st">实时到账</td>
									<td data-v-327351f8="" class="st">根据交易所限额</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
								<tr data-v-327351f8="" class="light">
									<td data-v-327351f8="" class="st">扫码转币</td>
									<td data-v-327351f8="" class="st">使用数字币钱包转账到{{$store.state.appInfo.title}}指定地址</td>
									<td data-v-327351f8="" class="st">20USDT-无上限</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
								<tr data-v-327351f8="" class="light">
									<td data-v-327351f8="" class="st">小金库</td>
									<td data-v-327351f8="" class="st">使用小金库钱包转账到指定地址</td>
									<td data-v-327351f8="" class="st">10USDT-无上限</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
							</tbody></table>
						</div>
						<div data-v-327351f8="" class="clear"></div>
					</div>
					<div data-v-327351f8="" class="row">
						<div data-v-327351f8="" class="table">
							<table data-v-327351f8="" width="1328" cellspacing="1" cellpadding="0">
								<tbody><tr data-v-327351f8="">
									<th data-v-327351f8="" width="230" class="first">取款方式</th>
									<th data-v-327351f8="" width="300">转账形式</th>
									<th data-v-327351f8="" width="250" class="ce">手续费</th>
									<th data-v-327351f8="" width="180" class="st">到账时间</th>
									<th data-v-327351f8="" width="200">交易限额</th>
									<th data-v-327351f8="" width="150" class="ce">如何取款</th>
								</tr>
								<tr data-v-327351f8="" class="light">
									<td data-v-327351f8="" class="icon1 mi"><img data-v-327351f8="" src="/static/image/rmb.0fae87c8.svg" class="img">人民币</td>
									<td data-v-327351f8="" class="st">第三方支付平台支付到银行卡</td>
									<td data-v-327351f8="">免费</td>
									<td data-v-327351f8="" class="st">2小时内</td>
									<td data-v-327351f8="" class="st">单日2000万CNY</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
								<tr data-v-327351f8="">
									<td data-v-327351f8="" class="icon1 mi"><img data-v-327351f8="" src="/static/image/crypto.c6750ec4.svg" class="img">数字币</td>
									<td data-v-327351f8="" class="st">第三方支付平台支付到指定地址</td>
									<td data-v-327351f8="">免费</td>
									<td data-v-327351f8="" class="st">30分钟内</td>
									<td data-v-327351f8="" class="st">单日300万USDT</td>
									<td data-v-327351f8=""><a data-v-327351f8="" class="introInfo">操作指引</a></td>
								</tr>
							</tbody></table>
						</div>
					</div>
				</div>
			</div>
</template>
<script>
export default {
  name: 'depositWays',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
   $(window).scroll(function () {
			if ($(document).scrollTop() <= $('.topicTopBar').height()) {
				$('.topicTopBar').show();
			} else {
				$('.topicTopBar').hide();
			}
		});
		//页面tab切换
		$('.navigation ul li').click(function () {
			var text = $(this).find('a').attr('title');
			$('.navigation').next('.title').text(text);
			var index = $(this).index();
			$('.bottom .guide').eq(index).slideDown(300).siblings().slideUp(0);
			$(this).addClass('active').siblings().removeClass('active');
			$('html,body').animate({ scrollTop: $('.navigation').offset().top }, 500);
		});

		//点击弹出视频
		$('.item-container .item').click(function () {
			var videoUrl = $(this).attr('data-url');
			$('#video').attr('src', videoUrl);
			$('#videoBox').fadeIn(500);
		});
		//点击弹出视频
		$('.videoClose').click(function () {
			$('#videoBox').fadeOut(0);
		});
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-1c9937b0.91a8cf3e.css';

 .faq .faq-container .row .group .a-row[data-v-3ecdc100] {
          display: none;
        }
</style>



// WEBPACK FOOTER //
// src/components/allMode/depositWays.vue